import { request } from "../network/request";
const db = "dn0";




//查询IT服务周报配置信息
export function selectXmzbExport(params) {
  return request({
    url: "pmp/xmzb/selectXmzbExport",
    method: "get",
    params: {
      db,
      ...params,
    },
  });
}

export function exportXmzb(params) {
  return request({
    url: 'pmp/xmzb/exportXmzb',
    method: "get",
    params: {
      db,
      ...params,
    },
  });
}

export function getWeekData() {
  return request({
    url: 'pmp/xmzb/getWeekData',
    method: "get",
    params: {
      db
    },
  });
}


